if (!customElements.get('product-recommendations')) {
	customElements.define('product-recommendations', class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
	  const renderOnce = () => {
		this.intersectionObserver?.disconnect();
		if (this.renderPromise) return;

		this.renderPromise = fetch(this.dataset.url)
		  .then(response => {
			if (!response.ok) throw new Error(`Product recommendations request failed: ${response.status}`);
			return response.text();
		  })
		  .then(text => {
			const html = document.createElement('div');
			html.innerHTML = text;
			const recommendations = html.querySelector('product-recommendations');
			const recommendationList = recommendations?.querySelector('.recommendation-list');

			if (recommendations && recommendationList) {
			  const finalContent = document.createDocumentFragment();
			  finalContent.append(...recommendations.childNodes);
			  this.replaceChildren(finalContent);
			  this.classList.add('product-recommendations--loaded');
			} else {
			  this.replaceChildren();
			  this.classList.add('hidden');
			}
		  })
		  .catch(e => {
			console.error(e);
			this.classList.add('hidden');
		  });
	  };

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
		renderOnce();
      }

	  this.intersectionObserver = new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 1200px 0px'});
	  this.intersectionObserver.observe(this);

	  const scheduleIdleRender = () => {
		if ('requestIdleCallback' in window) {
		  this.idleCallback = requestIdleCallback(renderOnce, { timeout: 2000 });
		} else {
		  this.idleCallback = setTimeout(renderOnce, 2000);
		}
	  };

	  if (document.readyState === 'complete') scheduleIdleRender();
	  else window.addEventListener('load', scheduleIdleRender, { once: true });
    }

	disconnectedCallback() {
	  this.intersectionObserver?.disconnect();
	  if (this.idleCallback) {
		if ('cancelIdleCallback' in window) cancelIdleCallback(this.idleCallback);
		else clearTimeout(this.idleCallback);
	  }
	}
  });
}
